export class ListGraphsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "graphs",
            "baseName": "graphs",
            "type": "Array<DashboardGraph>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGraphsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
